import * as types from "../types";

export const preLoginRequest = ({ requestUser }) => ({
  type: types.PRE_LOGIN_REQUEST,
  payload: {
    requestUser,
  },
});

export const preLoginSuccess = ({ otpData }) => ({
  type: types.PRE_LOGIN_SUCCESS,
  payload: {
    otpData,
  },
});

export const preLoginFailure = ({ error }) => ({
  type: types.PRE_LOGIN_FAILURE,
  payload: {
    error: error.message,
  },
});

export const preLoginReset = () => ({
  type: types.PRE_LOGIN_RESET,
});
